import { LuxuryItem } from '../types';

// Survive: Basic luxury items ($1k - $500k)
const surviveItems: LuxuryItem[] = [
  {
    name: 'iPhone 16 Pro 1TB',
    price: 1599,
    image: 'https://images.unsplash.com/photo-1678685888221-cda773a3dcdb?auto=format&fit=crop&q=80',
    description: 'Latest flagship iPhone with Titanium design and maximum storage',
    icon: 'smartphone'
  },
  {
    name: 'Rolex Submariner',
    price: 15000,
    image: 'https://images.unsplash.com/photo-1587836374828-4dbafa94cf0e?auto=format&fit=crop&q=80',
    description: 'Iconic luxury diving watch with timeless design',
    icon: 'watch'
  },
  {
    name: 'Tesla Model S Plaid',
    price: 135000,
    image: 'https://images.unsplash.com/photo-1617788138017-80ad40651399?auto=format&fit=crop&q=80',
    description: 'High-performance electric luxury sedan',
    icon: 'car'
  },
  {
    name: 'Luxury Condo',
    price: 450000,
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&q=80',
    description: 'Modern urban living space in prime location',
    icon: 'home'
  }
];

// Thrive: Premium luxury items ($500k - $10M)
const thriveItems: LuxuryItem[] = [
  {
    name: 'Lamborghini Huracán',
    price: 550000,
    image: 'https://images.unsplash.com/photo-1544829099-b9a0c07fad1a?auto=format&fit=crop&q=80',
    description: 'V10-powered supercar with cutting-edge aerodynamics',
    icon: 'car'
  },
  {
    name: 'Luxury Yacht',
    price: 5000000,
    image: 'https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?auto=format&fit=crop&q=80',
    description: '100-foot luxury yacht with full crew',
    icon: 'anchor'
  },
  {
    name: 'Miami Beach Penthouse',
    price: 8500000,
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&q=80',
    description: 'Luxury oceanfront penthouse in South Beach',
    icon: 'home'
  },
  {
    name: 'Helicopter (Bell 429)',
    price: 7500000,
    image: 'https://images.unsplash.com/photo-1534777367038-9404f45b869a?auto=format&fit=crop&q=80',
    description: 'Private luxury helicopter for urban mobility',
    icon: 'plane'
  }
];

// Flourish: Ultra luxury items ($10M+)
const flourishItems: LuxuryItem[] = [
  {
    name: 'Private Jet (Gulfstream G650)',
    price: 65000000,
    image: 'https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80',
    description: 'Ultra-long-range business jet',
    icon: 'plane'
  },
  {
    name: 'Private Island',
    price: 95000000,
    image: 'https://images.unsplash.com/photo-1559128010-7c1ad6e1b6a5?auto=format&fit=crop&q=80',
    description: 'Exclusive tropical paradise with pristine beaches and luxury villa',
    icon: 'home'
  },
  {
    name: 'Mega Yacht',
    price: 175000000,
    image: 'https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80',
    description: '300-foot mega yacht with helipad and submarine',
    icon: 'anchor'
  },
  {
    name: 'Private Bank',
    price: 250000000,
    image: 'https://images.unsplash.com/photo-1501167786227-4cba60f6d58f?auto=format&fit=crop&q=80',
    description: 'Your personal banking institution',
    icon: 'building-2'
  }
];

// Combine all items and sort by price
export const luxuryItems = [
  ...surviveItems,
  ...thriveItems,
  ...flourishItems
].sort((a, b) => a.price - b.price);